import React, { Fragment } from 'react'
import Select from 'react-select'
import _ from 'lodash'
import {
  Col,
  ContentSectionBlock,
  FormInput,
  FormInputCheckbox,
  FormInputDateRange,
  FormInputRadio,
  Row,
  Button
} from 'camino-react'

import { TAM, MANAGED, InvoicingReportContext } from './InvoicingReportContext'

const FilterPanel = () => (
  <ContentSectionBlock>
    <InvoicingReportContext.Consumer>
      {({ filters, updateFilters, gatherData, updateSelectAllClients, updateFiltersClientType }) => (
        <Fragment>
          <Row classExtra="row--bottom-spaced">
            {filters.canShowReviewed && (
              <Col>
                <FormInput label="Show Reviewed">
                  <FormInputCheckbox
                    onValue={value => updateFilters({ showReviewed: value })}
                    value={filters.showReviewed}
                  />
                </FormInput>
              </Col>
            )}
            <Col>
              <FormInput>
                <Row noGutters>
                  {_.map([MANAGED, TAM], clientType => (
                    <Col width={3}>
                      <FormInput label={clientType}>
                        <FormInputRadio
                          onValue={() => updateFiltersClientType({ clientType })}
                          value={filters.clientType === clientType}
                        />
                      </FormInput>
                    </Col>
                  ))}
                </Row>
              </FormInput>
            </Col>
          </Row>

          <Row>
            <Col>
              <FormInput label="Date range">
                <FormInputDateRange
                  value={[filters.startTime, filters.endTime]}
                  onValue={values => updateFilters(
                    { startTime: values[0], endTime: values[1] }
                  )}
                />
              </FormInput>
            </Col>
            <Col>
              <FormInput label="Show specific clients in this list">
                <Select
                  className="flex--grow Select--no-bottom-margin"
                  options={_.sortBy(filters.clients[filters.clientType], 'label')}
                  value={filters.clientsSelected}
                  onChange={selected => updateFilters({ clientsSelected: selected })}
                  placeholder="Select clients from the list..."
                  clearable
                  multi
                />
              </FormInput>
              <FormInput label="Select All">
                <FormInputCheckbox
                  onValue={value => updateSelectAllClients(value)}
                  value={filters.allClients}
                />
              </FormInput>
            </Col>
          </Row>
          <Button
            onClick={gatherData}
            disabled={_.isEmpty(filters.clientsSelected)}
          >
            Apply
          </Button>
        </Fragment>
      )}
    </InvoicingReportContext.Consumer>
  </ContentSectionBlock>
)

export default FilterPanel
